import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { TFunction } from 'i18next';

const columnHelper = createColumnHelper<Record<string, any>>();

interface GetCSVTableColumnsParams {
  t: TFunction;
  headers: string[];
  fileContent: string[][];
  isDefaultHeaderCorrect: boolean;
}

export const getCSVTableColumns = ({ t, headers, fileContent, isDefaultHeaderCorrect }: GetCSVTableColumnsParams): ColumnDef<Record<string, any>>[] => {
  const retrieveHeaderName = (index: number) => {
    return isDefaultHeaderCorrect ? fileContent[0]?.[index] : `${t('data_source_edit:file.header.column')} ${index + 1}`;
  };

  return headers.map((header, index) =>
    columnHelper.accessor(`col_${index}`, {
      id: `col_${index}`,
      header: () => retrieveHeaderName(index),
      cell: ({ getValue }) => <p className='truncate text-xs text-tertiary-600'>{getValue() as string}</p>,
      minSize: 130,
      maxSize: 130,
    })
  );
};
